import { render, staticRenderFns } from "./EmployeePreviousNext.vue?vue&type=template&id=3ea97534"
import script from "./EmployeePreviousNext.vue?vue&type=script&lang=js"
export * from "./EmployeePreviousNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports